import { gql } from "@apollo/client";

export const SAVE_REFERER = gql`
  mutation saveReferer($input: SaveRefererInput!) {
    saveReferer(input: $input)
  }
`;
